const { default: Sorter } = require("./sorter");

export default class IndexSorter extends Sorter {
    /** @inheritdoc */
    sort(a, b) {
        return (this.order === 'desc') ?
            parseInt(b.dataset.index) - parseInt(a.dataset.index) :
            parseInt(a.dataset.index) - parseInt(b.dataset.index);
    }
}